/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BusinessPermission,
    BusinessPermissionFromJSON,
    BusinessPermissionFromJSONTyped,
    BusinessPermissionToJSON,
} from './';

/**
 * 
 * @export
 * @interface BusinessAddUserBody
 */
export interface BusinessAddUserBody {
    /**
     * 
     * @type {string}
     * @memberof BusinessAddUserBody
     */
    email: string;
    /**
     * 
     * @type {Array<BusinessPermission>}
     * @memberof BusinessAddUserBody
     */
    permissions: Array<BusinessPermission>;
}

export function BusinessAddUserBodyFromJSON(json: any): BusinessAddUserBody {
    return BusinessAddUserBodyFromJSONTyped(json, false);
}

export function BusinessAddUserBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessAddUserBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'permissions': ((json['permissions'] as Array<any>).map(BusinessPermissionFromJSON)),
    };
}

export function BusinessAddUserBodyToJSON(value?: BusinessAddUserBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'permissions': ((value.permissions as Array<any>).map(BusinessPermissionToJSON)),
    };
}


